import ChartJsChartContainer from "../../../Components/Charts/ChartJsChart/ChartJsChartContainer";

const ChartJs = () => {
  return <ChartJsChartContainer />;
};

export default ChartJs;
